import styled from 'styled-components/macro'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import palette from 'src/designSystem/variables/palette'

// The live status/narration text under a running procedure (and the summary
// placeholder), typed via useTypewriter and styled subtle + italic like TI's
// StatusDisplay.
export const OeLiveNarration = styled.span<{ $truncate?: boolean }>`
  display: block;
  font-size: 12px;
  font-style: italic;
  color: ${palette.neutral[600]};
  min-height: 1.5em;
  ${({ $truncate }) =>
    $truncate &&
    `
    max-width: 350px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `}
`

// Tooltip body for the header narration: smaller, left-aligned text (shown with
// no arrow via the popover overlay) so the full update reads cleanly on hover.
export const OeTooltipBody = styled.span`
  display: block;
  font-size: 11px;
  line-height: 1.4;
  text-align: left;
`

// The "queued" placeholder row: an hourglass + text, shown in TEST DETAILS
// while a control's tests are enqueued (the status poll only surfaces
// per-procedure detail once a control starts running).
export const OeLiveLoadingRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 0;
`

// Glyph for a control whose OE tests are queued (not yet running) — shown in
// place of the running spinner on the control/section headers and beside the
// queued TEST DETAILS message. Muted so it reads as "waiting", not active. The
// icon is baked in by the OeQueuedIcon component (see OeLiveStatus.components).
export const StyledOeQueuedIcon = styled(FontAwesomeIcon)`
  font-size: 14px;
  color: ${palette.neutral[500]};
  margin-bottom: 1px;
`
